module.exports = __webpack_public_path__ + "img/view.e412b668.svg";